import TrainingSubscription from '../subscription';

/**
 * Create the action
 */

const { thunk, request, success, error } = TrainingSubscription.index((data, fetch) => {
    if (data.trainingId) {
        return fetch.get(`/trainings/${data.trainingId}/subscriptions`);
    }
    return fetch.get(`/training-subscriptions`);
});

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };
